import React, { useState, useEffect } from "react";
import DataTable from "./components/DataTable";
import Login from "./components/Login";
import { AuthData, Domains } from "./components/type/Data";
import ReportsByDomain from "./components/ReportsByDomain";
import { Button, Layout, Tabs, Tooltip } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { Header, Content, Footer } from "antd/es/layout/layout";
import logo from "./logo.webp";
import { PoweroffOutlined } from "@ant-design/icons";
import ProductListing from "./components/ProductListing";
import "./App.css";
import "./components/css/css.css"


enum Page {
  LOGIN,
  DATA_TABLE,
  QUOTE,
}

const App: React.FC = () => {
  useEffect(() => {}, []);

  const [page, setPage] = useState<Page>(Page.LOGIN);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userData, setUserData] = useState<{
    username: string;
    password: string;
    authData: AuthData;
    domains: Domains[];
  } | null>(null);
  const [activeTab, setActiveTab] = useState<string>("1"); // State to track the active tab

  const handleTabChange = (key: string) => {
    setActiveTab(key); // Update the active tab when it changes
  };

  const handleLogin = (
    username: string,
    password: string,
    authData: AuthData,
    domains: Domains[],
    isListing: boolean,
  ) => {
    // Perform login logic here
    // For demonstration purposes, let's just set loggedIn to true
    setLoggedIn(true);
    setUserData({ username, password, authData, domains });
    console.log("isListing", isListing);
    if (!isListing) {
      setPage(Page.DATA_TABLE);
    } else {
      setPage(Page.QUOTE);
    }
  };

  const handleBack = () => {
    setPage(Page.LOGIN);
  };

  return (
    <div style={{ verticalAlign: "center" }}>
      {page === Page.LOGIN && <Login onLogin={handleLogin} />}
      {page === Page.QUOTE && (
        <Layout>
          {/* <Header style={{ position: "fixed", zIndex: 1, width: "100%" }}> */}
          <Header
            style={{
              position: "fixed",
              zIndex: 1,
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}>
            <div>
              <img
                src={logo}
                className="App-logo"
                alt="logo"
                style={{
                  height: "60px",
                }}
              />
            </div>
            <div style={{ paddingRight: "22px", paddingTop: "10px" }}>
              {/* <Button style={} onClick={handleBack}>Back</Button> */}
              <Tooltip title="Log out">
                <Button
                  type="primary"
                  icon={<PoweroffOutlined />}
                  // loading={loadings[1]}
                  onClick={handleBack}
                />
              </Tooltip>
            </div>
          </Header>
          <Content
            style={{
              padding: "64px 50px 64px",
              marginTop: 64,
              overflowY: "auto",
              maxHeight: "calc(100vh - 128px)",
            }}><ProductListing/>
            </Content>
          <Footer
            style={{
              bottom: 0,
              width: "100%",
              textAlign: "center",
              position: "fixed",
            }}>
            © {new Date().getFullYear()} Tharon Technologies
          </Footer>
        </Layout>
      )}

      {page === Page.DATA_TABLE && (
        <Layout>
          {/* <Header style={{ position: "fixed", zIndex: 1, width: "100%" }}> */}
          <Header
            style={{
              position: "fixed",
              zIndex: 1,
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}>
            <div>
              <img
                src={logo}
                className="App-logo"
                alt="logo"
                style={{
                  height: "60px",
                }}
              />
            </div>
            <div style={{ paddingRight: "22px", paddingTop: "10px" }}>
              {/* <Button style={} onClick={handleBack}>Back</Button> */}
              <Tooltip title="Log out">
                <Button
                  type="primary"
                  icon={<PoweroffOutlined />}
                  // loading={loadings[1]}
                  onClick={handleBack}
                />
              </Tooltip>
            </div>
          </Header>
          <Content
            style={{
              padding: "64px 50px 64px",
              marginTop: 64,
              overflowY: "auto",
              maxHeight: "calc(100vh - 128px)",
            }}>
            <div style={{ background: "#fff", padding: 24, minHeight: 380 }}>
              <Tabs defaultActiveKey="2" activeKey={activeTab} onChange={handleTabChange}>
                <TabPane tab="All Reports" key="1">
                  {activeTab === "1" && (
                    <DataTable
                      username={userData?.username || ""}
                      password={userData?.password || ""}
                      authData={userData?.authData as AuthData}
                      domains={userData?.domains as Domains[]}
                      onBack={handleBack}
                    />
                  )}
                </TabPane>
                <TabPane tab="Reports by customers" key="2">
                  {activeTab === "2" && (
                    <ReportsByDomain
                      username={userData?.username || ""}
                      password={userData?.password || ""}
                      authData={userData?.authData as AuthData}
                      domains={userData?.domains as Domains[]}
                      onBack={handleBack}
                    />
                  )}
                </TabPane>
              </Tabs>
            </div>
          </Content>
          <Footer
            style={{
              bottom: 0,
              width: "100%",
              textAlign: "center",
              position: "fixed",
            }}>
            © {new Date().getFullYear()} Tharon Technologies
          </Footer>
        </Layout>
      )}
    </div>
  );
};

export default App;

